import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import cloneDeep from 'lodash/cloneDeep';

import { IUsr0102MState, IApprRefUsrItemState, IOffReqInfoState, IOffDcdState } from '../../models/usr/usr0102m_model';
  
const initialState: IUsr0102MState = {
    offReqInfo: {},         // 휴가요청정보
    approvalList: [],       // 결재자목록 
    refList: [],            // 참조자목록
    apprOpns: [],           // 결재의견목록
    apprOpn: '',            // 결재의견
    offDcdList: [],         // 휴가구분코드목록
}

export const usr0102m_Slice = createSlice({
    name: "usr0102m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            const offDcdList = state.offDcdList;
            const newState = cloneDeep(initialState);
            newState.offDcdList = offDcdList;
            newState.offReqInfo = { offDcd : offDcdList && offDcdList.length > 0 ? offDcdList[0].value : '1' };

            return newState;
        },
        setOffReqInfo: (state, action:PayloadAction<IOffReqInfoState>) => {
            state.offReqInfo = action.payload;
        },
        setApprovalList: (state, action:PayloadAction<IApprRefUsrItemState[]>) => {
            state.approvalList = action.payload;
        },
        setRefList: (state, action:PayloadAction<IApprRefUsrItemState[]>) => {
            state.refList = action.payload;
        },
        setApprOpns: (state, action:PayloadAction<any[]>) => {
            state.apprOpns = action.payload;
        },
        setApprOpn: (state, action:PayloadAction<string>) => {
            state.apprOpn = action.payload;
        },
        setOffDcdList: (state, action:PayloadAction<IOffDcdState[]>) => {
            state.offDcdList = action.payload;
        },
    },
});

export default usr0102m_Slice.reducer;
export const Usr0102mAction  = usr0102m_Slice.actions;
export const Usr0102mReducer = usr0102m_Slice.reducer;